import "./es6-polyfill";
import "./closest";
import svg4everybody from "svg4everybody";
import "./modernizr.cssmask.js";

svg4everybody();
